module.exports = __webpack_public_path__ + "static/media/icon_monitoring.1dbb5b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon_monitoring.svg
// module id = 452
// module chunks = 0